import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import './Styles/index.css';
import registerServiceWorker from './Services/registerServiceWorker';

const main = function() {
  console.info('Rendering app');
  ReactDOM.render(<App />, document.getElementById('root'));
  registerServiceWorker();
};
main();
